/**
 * @file paddle 客户案例 案例列表
 * @author wanzhongyun
 */
import React from 'react';
import {Col, Row} from 'antd';
import classNames from 'classnames';

import A from '../../../../components/a/A';
import {ICaseList} from './../../types';

const EnterpriseCaseList: React.FC<ICaseList> = props => {
    const { caseList } = props;

    // 消除魔法字符串
    const mouseTypeMap = {
        ENTER: Symbol('enter'),
        LEAVE: Symbol('leave')
    };

    const handleMouse = (type: symbol ,index: number) => {
        const itemDom = Array.from(document.querySelectorAll('.paddle-cc-case-list-item'))[index] as HTMLDivElement;
        const textDom = Array.from(document.querySelectorAll('.paddle-cc-case-list-item-text'))[index] as HTMLDivElement;

        if (type === mouseTypeMap.ENTER) {
            const height = textDom.getBoundingClientRect().height;
            itemDom.style.height = `${342 + (height - 110)}px`;
        }
        else {
            itemDom.style.height = '342px';
        }
    };

    return (
        <div className="paddle-cc-case-list">
            <div className="paddle-cc-case-list-body">
                <Row gutter={20}>
                    {caseList.map((item, index) => (
                        <Col
                            className="paddle-cc-case-list-item-wrap"
                            xs={8}
                            key={item.caseName + item.casePath}
                        >
                            <div className='paddle-cc-case-list-item-wrapper'>
                            <div
                                className={classNames(
                                    'paddle-cc-case-list-item',
                                    !!item.casePath && 'paddle-cc-case-list-item-with-link'
                                )}
                                onMouseEnter={() => handleMouse(mouseTypeMap.ENTER, index)}
                                onMouseLeave={() => handleMouse(mouseTypeMap.LEAVE ,index)}
                            >
                                <A
                                    className="paddle-cc-case-list-item-inner"
                                    href={item.casePath}
                                    target
                                >
                                    <div
                                        className="paddle-cc-case-list-item-icon"
                                        style={{backgroundImage: item.logo ? `url(${item.logo})` : undefined}}
                                    />
                                    <div className="paddle-cc-case-list-item-title">
                                        {item.caseName}
                                    </div>
                                    <div className="paddle-cc-case-list-item-text">
                                        {item.des}
                                    </div>
                                </A>
                                <div className="paddle-cc-case-list-item-about">
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td>
                                                Related Products:
                                            </td>
                                            <td>
                                                {item.products.map(p => (
                                                    <A
                                                        className="paddle-cc-case-list-item-about-link"
                                                        key={`${p.href}${p.name}`}
                                                        href={p.href}
                                                        target
                                                    >
                                                        {p.name}
                                                    </A>
                                                ))}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>
        </div>
    );
};

export default EnterpriseCaseList;
